'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashArrayFlattenDeep = require('lodash/array/flattenDeep');

var _lodashArrayFlattenDeep2 = _interopRequireDefault(_lodashArrayFlattenDeep);

var _ControlNoop = require('./ControlNoop');

var _ControlNoop2 = _interopRequireDefault(_ControlNoop);

var style = {
  background: '#eee',
  overflow: 'hidden',
  fontFamily: 'Menlo, Monaco, Consolas, "Lucida Console", monospace'
};
var styleItemTop = {
  float: 'left',
  width: '280px'
};
var styleItemSide = {
  marginBottom: '4px'
};

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.Layout',

  propTypes: {
    children: _react.PropTypes.node.isRequired,
    onTop: _react.PropTypes.bool.isRequired
  },

  renderChildren: function renderChildren() {
    var _props = this.props;
    var onTop = _props.onTop;
    var children = _props.children;

    var childStyles = onTop ? styleItemTop : styleItemSide;
    return _lodashArrayFlattenDeep2['default'](children).filter(function (x) {
      return x && x.type !== _ControlNoop2['default'];
    }).map(function (x, i) {
      return _react2['default'].createElement(
        'div',
        { key: i, style: childStyles, className: 'react-demo__control-wrap' },
        x
      );
    });
  },

  render: function render() {
    return _react2['default'].createElement(
      'div',
      { style: style, className: 'react-demo__controls' },
      this.renderChildren()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/Layout.js
// module id = 968
// module chunks = 0